import React, { useState } from 'react';
import { Outlet, NavLink, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const navItems = [
  { path: '/', label: 'Dashboard', end: true },
  { path: '/appointments', label: 'My Appointments' },
  { path: '/waivers', label: 'My Consent Forms' },
  { path: '/book', label: 'Book Service' },
  { path: '/loyalty', label: 'Loyalty & Rewards' },
  { path: '/gift-cards', label: 'Gift Cards' },
  { path: '/wallet', label: 'My Wallet' },
  { path: '/profile', label: 'My Profile' },
];

export default function AppLayout() {
  const { user, logout, isStaff, isManager, isSuperAdmin } = useAuth();
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const loc = useLocation();
  const doLogout = () => { logout(); navigate('/login'); };
  const initials = (user?.firstName?.[0] || '') + (user?.lastName?.[0] || '');
  const isActive = (path, end) => end ? loc.pathname === path : loc.pathname.startsWith(path);

  return (
    <>
      <div className="mobile-header" style={{ background: '#fff', borderBottom: '2px solid #5B9E8F' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <div className="hamburger" onClick={() => setOpen(!open)} style={{ color: '#25302C' }}><span /><span /><span /></div>
          <span style={{ fontFamily: 'var(--rr-font-heading)', fontSize: 17, color: '#25302C' }}>Royal Revitalization</span>
        </div>
        <button className="btn btn-gold btn-sm" onClick={() => navigate('/book')}>Book</button>
      </div>
      <div className={`sidebar-overlay ${open ? 'open' : ''}`} onClick={() => setOpen(false)} />
      <div className="app-container" style={{ background: '#FAF9F7' }}>
        <aside className={`app-sidebar ${open ? 'open' : ''}`} style={{ background: '#FFFFFF', borderRight: '3px solid #5B9E8F', padding: '38px 24px 32px', gap: 38 }}>
          <div>
            <div style={{ fontFamily: 'var(--rr-font-heading)', fontSize: 27, lineHeight: 1.05, fontWeight: 500, color: '#25302C' }}>Royal<br />Revitalization</div>
            <div style={{ width: 34, height: 1, background: '#C9A84C', marginTop: 12 }} />
            <div style={{ fontFamily: 'var(--rr-font-mono)', fontSize: 10, letterSpacing: '.22em', color: '#5B9E8F', marginTop: 14 }}>CLIENT PORTAL</div>
          </div>

          <nav style={{ display: 'flex', flexDirection: 'column', gap: 4, flex: 1 }}>
            {navItems.map(item => {
              const active = isActive(item.path, item.end);
              return (
                <NavLink key={item.path} to={item.path} end={item.end} onClick={() => setOpen(false)}
                  style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '11px 14px', borderRadius: 0, borderLeft: active ? '2px solid #5B9E8F' : '2px solid transparent', color: active ? '#3F7A6C' : '#7C867F', background: active ? 'rgba(91,158,143,.06)' : 'transparent', textDecoration: 'none', fontSize: 14, fontWeight: active ? 500 : 400, transition: 'all .14s' }}>
                  {item.label}
                </NavLink>
              );
            })}
          </nav>

          {(isStaff || isManager || isSuperAdmin) && <div style={{ paddingTop: 18, borderTop: '1px solid #E7E3DC', display: 'flex', flexDirection: 'column', gap: 6 }}>
            <div style={{ fontSize: 9.5, fontWeight: 700, letterSpacing: '.14em', color: '#9AA39C', marginBottom: 4 }}>SWITCH PORTAL</div>
            {isSuperAdmin &&  <NavLink to="/admin" onClick={() => setOpen(false)} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '9px 12px', borderRadius: 8, background: 'rgba(255,255,255,.05)', color: '#C7C7D6', fontSize: 13, fontWeight: 600, textDecoration: 'none' }}>Super Admin <span style={{ opacity:.5 }}>→</span></NavLink>}
            {isManager && <NavLink to="/manager" onClick={() => setOpen(false)} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '9px 12px', borderRadius: 8, background: 'rgba(255,255,255,.05)', color: '#C7C7D6', fontSize: 13, fontWeight: 600, textDecoration: 'none' }}>Manager Portal <span style={{ opacity:.5 }}>→</span></NavLink>}
            {isStaff &&  <NavLink to="/staff" onClick={() => setOpen(false)} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '9px 12px', borderRadius: 8, background: 'rgba(255,255,255,.05)', color: '#C7C7D6', fontSize: 13, fontWeight: 600, textDecoration: 'none' }}>Staff Portal <span style={{ opacity:.5 }}>→</span></NavLink>}
          </div>}

          <div style={{ display: 'flex', alignItems: 'center', gap: 12, paddingTop: 22, borderTop: '1px solid #E7E3DC' }}>
            <div style={{ width: 38, height: 38, borderRadius: '50%', background: '#EDF3F1', color: '#3F7A6C', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'var(--rr-font-heading)', fontSize: 15 }}>{initials}</div>
            <div style={{ flex: 1 }}>
              <div style={{ fontSize: 13.5, color: '#25302C' }}>{user?.firstName} {user?.lastName}</div>
              <div style={{ fontSize: 11, color: '#7C867F' }}>{user?.role?.replace('_', ' ')}</div>
            </div>
            <button onClick={doLogout} style={{ background: 'none', border: 'none', color: '#9AA39C', cursor: 'pointer', fontSize: 11, fontWeight: 600 }}>Sign Out</button>
          </div>
        </aside>
        <main className="app-main" style={{ padding: '52px 60px 80px', display: 'flex', justifyContent: 'center', background: '#FAF9F7' }}>
          <div style={{ width: '100%', maxWidth: 1120, animation: 'rrFade .28s ease both' }}><Outlet /></div>
        </main>
      </div>
    </>
  );
}
